var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',{attrs:{"title":_vm.$t('パスワードの再設定'),"desc":_vm.$t('メールに記載されているアドレスから、パスワードを再設定してください。'),"img":"@/assets/auth/img-login.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }